import $ from "jquery";
import React, { createRef, } from "react";
import "jquery-ui-sortable";
window.jQuery = $;
window.$ = $;

require("formBuilder");



function CreateForm() {
  const fb = createRef();

  const getUpdate = () => {
  };

 

  return (
    <div>
      <div id="fb-editor" ref={fb} />
      <button onClick={getUpdate}>Get Data</button>
    </div>
  );
}

export default CreateForm;
